import { useJsApiLoader, Libraries } from "@react-google-maps/api";

/**
 * Loader do Google Maps JS API. Replica o padrão do rf-gestaofrota-cliente-web
 * (contexts/GoogleMapsContext): carrega a biblioteca `visualization` exigida pelo
 * HeatmapLayer. A key vem de REACT_APP_GOOGLE_MAPS_API_KEY.
 *
 * `libraries` fica fora do componente (referência estável) — recarregar com um
 * array novo a cada render dispara warning do @react-google-maps/api.
 */
const LIBRARIES: Libraries = ["visualization"];

export const useGoogleMaps = () => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
    libraries: LIBRARIES,
    version: "3.64",
    language: "pt-BR",
    region: "BR",
  });

  return { isLoaded, loadError };
};
